import { ClassicWizard, type WizardComponent } from '@unipile/ui';
import { LoginScreen } from './WizardLoginScreen';

export const Wizard: WizardComponent = ({ onSuccess, onError, onCancel }) => {
  return <ClassicWizard Component={LoginScreen} onSuccess={onSuccess} onError={onError} onCancel={onCancel} />;
};
